module.exports = __webpack_public_path__ + "img/foot-wx.3b48dd03.png";